export function PlaceholderCell() {
  return '(Placeholder)';
}
